
export default class TeamMemberCardDescriptionHandler {
  constructor() {
    this.maxLength = 250;
    this.ellipsis = '...';
    this.readMoreText = 'Read more';
    this.readLessText = 'Read less';
    this.init();
  }

  init() {
    const teamMemberDescriptions = document.querySelectorAll('.team-member__card__desc p');
    
    if (teamMemberDescriptions.length) {
      this.truncateDescriptions(teamMemberDescriptions);
    }
    
    this.handleBioMobileDetails();
  }

  truncateDescriptions(descriptions) {
    descriptions.forEach(description => {
      const originalText = description.textContent;
      
      if (originalText.length > this.maxLength) {
        const truncatedText = originalText.substring(0, this.maxLength).trim() + this.ellipsis;
        description.textContent = truncatedText;
      }
    });
  }
  
  handleBioMobileDetails() {
    const bioMobileDetails = document.querySelectorAll('.team-member__card__bio-mobile');
    
    if (bioMobileDetails.length) {
      bioMobileDetails.forEach(detail => {
        const summary = detail.querySelector('summary');
        
        if (summary) {
          // Set initial text if not already set
          if (!summary.dataset.originalText) {
            summary.dataset.originalText = summary.textContent.trim();
          }
          
          // Check if detail is open and set appropriate text
          if (detail.hasAttribute('open')) {
            summary.textContent = this.readLessText;
          } else {
            summary.textContent = summary.dataset.originalText || this.readMoreText;
          }
          
          // Add event listener to toggle text on click
          detail.addEventListener('toggle', () => {
            if (detail.hasAttribute('open')) {
              summary.textContent = this.readLessText;
            } else {
              summary.textContent = summary.dataset.originalText || this.readMoreText;
            }
          });
        }
      });
    }
  }
}